import React from "react";
import { useParams } from "react-router-dom";

// Windows
import BlogList from "./BlogList/BlogList";
import BlogPost from "./BlogPost/BlogPost";

const BlogWindow = ({ lang, setHoveredElement }) => {
  const { id } = useParams();

  return (
    <div className="BlogWindow">
      {!id ? (
        <BlogList lang={lang} setHoveredElement={setHoveredElement} />
      ) : (
        <BlogPost lang={lang} id={id} setHoveredElement={setHoveredElement} />
      )}
    </div>
  );
};

export default BlogWindow;
